<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import {smoothScroll} from "@/js/utils/smoothScroll";

const props = defineProps({
    targetSelector: {
        type: String,
        required: true,
    },
})

const isShow = ref(false)

let observer = null

const handleClick = () => {
    smoothScroll('#wrapper')
}

defineOptions({
    name: 'PageTop'
})

onMounted(() => {
    const target = document.querySelector(props.targetSelector)
    if (!target) return

    observer = new IntersectionObserver(
        ([entry]) => {
            // wrapperが見えている = ページトップ付近 → 非表示
            isShow.value = !entry.isIntersecting
        },
        // IntersectionObserverインスタンス化
        // @param {Object, Null} [root] ターゲットとなる要素が見えるかどうかを判定するためのベース部分を指定する。デフォルトはブラウザーのビューポート。
        // @param {String} [rootMargin] 交差を検知する、root からの距離
        // @param {Number} [threshold] 関数を実行するタイミング（0〜1 の間）
        {
            root: null,
            threshold: 0,
        }
    )

    observer.observe(target)
})

onUnmounted(() => {
    observer?.disconnect()
})
</script>

<template>
    <transition name="page_top-transition">
        <p class="page_top" v-if="isShow"><a href="#" @click.prevent="handleClick">PAGE TOP</a></p>
    </transition>
</template>

<style scoped>

</style>
